/**
 * Created by 芋道源码
 *
 * 数据字典工具类
 */
import store from "@/store";

export const DICT_TYPE = {
  JUMP_TYPE: "jump_type", // banner跳转类型
  BANNER_POSITION: "banner_position", //banner位置
  NEWS_TYPE: "news_type", //新闻资讯分类
  POSTAGE_TYPE: "postage_type", //邮费计费方式
  ORDER_STATUS: "order_status", //订单状态
  CONTENT_REVIEW_STATUS: "content_review_status", //圈子状态
  APPLY_REFUND_STATUS: "apply_refund_status", //售后状态
  SYSTEM_TYPE: "system_type", //系统类型
  UPDATE_TYPE: "update_type", //更新类型
  MANUFACTURER: "manufacturer", //更新类型
  QUALITY_TESTING_STATUS: "quality_testing_status", //质检状态
  LANGUAGE: "language", //语言
  SCREEN_ORIENTATION: "screen_orientation", //屏幕方向
  WEB_GAME_TYPE: "web_game_type", //网页游戏类型
  ROM_GAME_TYPE: "rom_game_type", //rom游戏类型
  ROM_TYPE: "rom_type", //rom类型
  ROM_SUPPORTED_PLATFORM: "rom_supported_platform", //rom支持平台
  STATUS: "status", //rom支持平台
};

/**
 * 获取 dictType 对应的数据字典数组
 *
 * @param dictType 数据类型
 * @returns {*|Array} 数据字典数组
 */
export function getDictDatas(dictType) {
  return store.getters.dict_datas[dictType] || [];
}

/**
 * 获取 dictType 对应的数据字典数组
 *
 * @param dictType 数据类型
 * @param values 数组、单个元素
 * @returns {*|Array} 数据字典数组
 */
export function getDictDatas2(dictType, values) {
  if (values === undefined) {
    return [];
  }
  // 如果是单个元素，则转换成数组
  if (!Array.isArray(values)) {
    values = [this.value];
  }
  // 获得字典数据
  const results = [];
  for (const value of values) {
    const dict = getDictData(dictType, value);
    if (dict) {
      results.push(dict);
    }
  }
  return results;
}

export function getDictData(dictType, value) {
  // 获取 dictType 对应的数据字典数组
  const dictDatas = getDictDatas(dictType);
  if (!dictDatas || dictDatas.length === 0) {
    return "";
  }
  // 获取 value 对应的展示名
  // value = value + ""; // 强制转换成字符串，因为 DictData 小类数值，是字符串

  for (const dictData of dictDatas) {
    if (dictData.value === value) {
      return dictData;
    }
  }
  return undefined;
}

export function getDictDataLabel(dictType, value) {
  const dict = getDictData(dictType, value);
  // console.log("dict :>> ", value);
  return dict ? dict.label : "";
}
